module.exports = __webpack_public_path__ + "6b6a2c6dddc2633029ee18371a86980a.png";